import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

const tenant = 'hoppenbrouwersb2c';
const clientId = '5262e35a-aa48-4646-9fa7-88e52c6aaed2';

export const msalConfig: IPublicClientApplication = new PublicClientApplication({
  auth: {
    clientId,
    authority: `https://${tenant}.b2clogin.com/tfp/${tenant}.onmicrosoft.com/B2C_1_external_susi`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/b2c_1_external_susi/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
    knownAuthorities: [`https://${tenant}.b2clogin.com/`],
  },
  cache: { cacheLocation: BrowserCacheLocation.LocalStorage },
  system: { allowPlatformBroker: false },
});

const scopes: string[] = [`https://${tenant}.onmicrosoft.com/${clientId}/access_as_user`, 'openid'];

const protectedResourceMap = new Map<string, string[]>([
  ['https://graph.microsoft.com/v1.0/me', [`https://${tenant}.onmicrosoft.com/${clientId}/User.Read`]],
  ['/api/graphql', scopes],
]);

export const msalAngularConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap,
};

export const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: { scopes },
};
